// @flow
import { OPACITY_LEVEL, TRANSITION_DEF } from '../constants';

import styled from 'styled-components';

export const Container = styled.g`
    opacity: ${p => (p.fade ? OPACITY_LEVEL : 1)};
    transition: ${TRANSITION_DEF};
`;

export const Label = styled.text`text-anchor: middle;`;

export const CurrentTimeBorder = styled.rect`
    fill: ${p => p.theme.white};
    stroke: ${p => p.theme.mediumGrey};
    stroke-width: 2;
    height: ${p => p.height}px;
    width: ${p => p.width}px;
`;

export const CurrentTimeContainer = styled.g`transition: ${TRANSITION_DEF};`;

export const CurrentTimeLabel = styled.text`
    font-size: 0.8em;
    text-anchor: middle;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/time-axis/style.js